<template>
  <div class="g-content">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <a-form-model :model="searchForm" :rules="rules" layout="inline" ref="formElement">
          <!-- role -->
          <a-form-model-item :label="$t('user_form_role')" prop="roleId" v-if="roleList">
            <a-select
              v-model="searchForm.roleId"
              :placeholder="$t('user_form_role_all')"
              style="min-width:300px;"
              show-search
              allowClear
              @change="getList()"
              :filter-option="
                (input, option) => {
                  return (
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              "
            >
              <a-select-option :value="item.id" v-for="item in roleList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <!-- 关键字 -->
          <a-form-model-item :label="null" prop="keyword">
            <a-input-search
              v-model="searchForm.keyword"
              style="min-width:300px"
              :placeholder="$t('com_form_keyword_input')"
              allowClear
              @search="getList()"
            />
          </a-form-model-item>

          <!-- 提交 -->
          <a-form-model-item style="margin:0">
            <a-button type="primary" @click.prevent="getList(1)" style="margin-right:10px;">
              {{ $t('com_btn_search') }}
            </a-button>
          </a-form-model-item>

          <!-- 重置 -->
          <a-form-model-item>
            <a-button @click="onSearchReset">
              {{ $t('com_btn_reset') }}
            </a-button>
          </a-form-model-item>
        </a-form-model>
        <router-link :to="{ name: 'UserAdd' }" v-auth="['auth_user_add']" style="display: flex;">
          <a-button type="primary" icon="plus">
            {{ $t('com_btn_user_add') }}
          </a-button>
        </router-link>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="g-table">
        <Loading :show="true" v-if="loading" />
        <NetworkError v-else-if="networkError" style="margin-top:0;" />
        <a-table
          :columns="columns"
          :data-source="list"
          bordered
          :rowKey="(_text, index) => index"
          :pagination="false"
          :loading="tableLoading"
          v-else
        >
          <!-- 名称  -->
          <template slot="name" slot-scope="text, record">
            <span class="g-table-text">
              <router-link
                :to="{ name: 'UserDetail', params: { id: record.userId } }"
                v-if="
                  (authList.includes('auth_user') &&
                    authList.includes('auth_user_list') &&
                    authList.includes('auth_user_detail')) ||
                    isSuperAdmin
                "
              >
                {{ text }}
              </router-link>
              <span v-else>
                {{ text }}
              </span>
              <a-icon
                type="copy"
                @click="copyContent(`#user_list_${record.userId}`)"
                :data-clipboard-text="`${text}`"
                data-clipboard-action="copy"
                :id="`user_list_${record.userId}`"
                title="Copy"
                style="color:#ccc"
              />
            </span>
          </template>

          <!-- 昵称 -->
          <template slot="nickName" slot-scope="text, record">
            {{ text }}
            <a-icon
              type="copy"
              @click="copyContent(`#user_list_nickName_${record.name}`)"
              :data-clipboard-text="`${text}`"
              data-clipboard-action="copy"
              :id="`user_list_nickName_${record.name}`"
              title="Copy"
              style="color:#ccc"
              v-if="text"
            />
          </template>

          <!-- 创建时间  -->
          <template slot="createTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 是否平台用户 -->
          <template slot="Platform" slot-scope="text">
            <span v-if="text" style="color:#1838d9">✓</span>
          </template>

          <!-- 状态 -->
          <template slot="Status" slot-scope="text">
            <div class="g-status">
              <span v-if="text" class="g-status-disabled">
                {{ $t('com_form_disabled') }}
              </span>
              <span v-else class="g-status-enabled">
                {{ $t('com_form_enabled') }}
              </span>
            </div>
          </template>

          <!-- email -->
          <template slot="Email" slot-scope="text, record">
            {{ text }}
            <a-icon
              type="copy"
              @click="copyContent(`#user_list_email_${record.record}`)"
              :data-clipboard-text="`${text}`"
              data-clipboard-action="copy"
              :id="`user_list_email_${record.record}`"
              title="Copy"
              style="color:#ccc"
              v-if="text"
            />
          </template>

          <!-- customer -->
          <template slot="customerName" slot-scope="text, record">
            <!-- 编辑 -->
            <router-link
              :to="`/manage/system/customer/detail/${record.customerId}`"
              v-if="
                (authList.includes('auth_customer') &&
                  authList.includes('auth_customer_list') &&
                  authList.includes('auth_customer_detail')) ||
                  isSuperAdmin
              "
            >
              {{ text }}
            </router-link>

            <span v-else>{{ text }}</span>
          </template>

          <!-- 操作栏 -->
          <template slot="Action" slot-scope="text, record">
            <!-- 编辑 -->
            <router-link
              :to="{ name: 'UserUpdate', params: { id: record.userId } }"
              v-auth="['auth_user_edit']"
            >
              <a-button type="primary" size="small">
                {{ $t('com_btn_edit') }}
              </a-button>
            </router-link>

            <!-- 修改密码 -->
            <a-button
              type="dashed"
              @click="showChangePassword(record)"
              v-auth="['auth_user_change_password']"
              size="small"
            >
              {{ $t('user_btn_change_password') }}
            </a-button>

            <!-- 配置权限 -->
            <router-link
              :to="{ name: 'UserAuth', params: { id: record.userId } }"
              v-auth.and="['auth_user_authData', 'auth_user_customerStationList']"
              v-if="userInfo.user.userName !== record.name"
            >
              <a-button type="primary" size="small">
                {{ $t('com_btn_auth') }}
              </a-button>
            </router-link>

            <!-- 禁用 -->
            <a-button
              type="enable"
              @click="disabled(record, false)"
              v-if="record.disable"
              v-auth="['auth_user_disableEnable']"
              size="small"
            >
              {{ $t('com_form_enabled') }}
            </a-button>

            <a-button
              type="yellow"
              @click="disabled(record, true)"
              v-if="!record.disable && userInfo.user.userName !== record.name"
              v-auth="['auth_user_disableEnable']"
              size="small"
            >
              {{ $t('com_btn_disabled') }}
            </a-button>

            <!-- 删除 -->
            <a-button
              type="red"
              @click="remove($event, record)"
              v-auth="['auth_user_delete']"
              size="small"
              v-if="userInfo.user.userName !== record.name"
            >
              {{ $t('com_btn_delete') }}
            </a-button>
          </template>
        </a-table>

        <Pagination
          :current="pagination.current"
          :total="pagination.total"
          :pageSize.sync="pagination.pageSize"
          :callback="getList"
          @change="getList"
        />

        <!-- 编辑/添加 Customer -->
        <ChangePassword ref="changePassword" v-auth="['auth_user_change_password']" />
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/system/user';
import ChangePassword from './components/changePassword.vue';
import { mapGetters } from 'vuex';
import { copyContent } from '@/libs/utils';

export default {
  components: {
    ChangePassword,
  },

  data() {
    return {
      copyContent,
      loading: true,
      tableLoading: false,

      rules: {},
      // 搜索
      searchForm: {
        keyword: undefined,
        roleId: undefined,
        orderType: 0,
      },

      columns: [
        {
          title: '#',
          align: 'center',
          width: 60,
          customRender: (text, record, index) => {
            return (this.pagination.current - 1) * this.pagination.pageSize + (index + 1);
          },
        },
        {
          title: this.$t('user_table_userName'),
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: this.$t('user_form_role'),
          dataIndex: 'roleName',
        },

        {
          title: this.$t('com_table_status'),
          dataIndex: 'disable',
          align: 'center',
          scopedSlots: { customRender: 'Status' },
        },

        {
          title: this.$t('user_table_belonged_customer'),
          dataIndex: 'customerName',
          scopedSlots: { customRender: 'customerName' },
        },

        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],
      list: [],
      // 分页
      pagination: {
        // 当前页码
        current: Number(this.$route.query.pageNo) || 1,
        // 每页显示
        pageSize: 10,
        // 记录总条数
        total: 0,
      },

      // 角色列表
      roleList: null,

      networkError: false,
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin', 'userInfo']),
  },
  created() {
    // 获取user list
    this.getData();

    // 权限
    if (
      this.authList.includes('auth_user_authData') ||
      this.authList.includes('auth_user_edit') ||
      this.authList.includes('auth_user_change_password') ||
      this.authList.includes('auth_user_disableEnable') ||
      this.authList.includes('auth_user_delete') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        scopedSlots: { customRender: 'Action' },
      });
    }
  },
  methods: {
    // 重置表单
    onSearchReset() {
      this.$refs.formElement.resetFields();
      this.getList();
    },

    // 获取表单数据
    getData() {
      const _list = [this.getList()];

      // 配置
      if (this.authList.includes('auth_user_role_list') || this.isSuperAdmin) {
        _list.push(this.getRoleList());
      }

      Promise.all(_list).finally(() => {
        this.$store.commit('setPageLoading', false);
      });
    },

    // 获取权限列表
    getRoleList() {
      API.RoleListSelect().then(res => {
        if (res.code === 0) {
          this.roleList = res.data;
        }
      });
    },

    getList(pageNo) {
      this.pagination.current = pageNo || 1;
      const params = {
        ...this.searchForm,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };

      this.tableLoading = true;
      this.networkError = false;
      return API.UserList(params)
        .then(res => {
          if (res.code === 0) {
            this.loadSuccess(res);
          }
        })
        .catch(() => {
          this.networkError = true;
        })
        .finally(() => {
          this.loadComplete();
        });
    },

    loadComplete() {
      this.loading = false;
      this.tableLoading = false;
    },

    // 成功
    loadSuccess(res) {
      this.list = res.data || [];

      // total
      this.pagination.total = res.totalCount;
    },

    // 禁用
    disabled(record, disable) {
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('user_confirm_disabled_title'),
        content: h('div', {}, [h('p', this.$t('user_confirm_content', { name: record.name }))]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_disable'));
          API.UserDisable({ userId: record.userId, disable: disable })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_disabled_success'));

                // 重新获取列表
                this.getList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 删除
    remove(_$event, record) {
      const _this = this;
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('user_confirm_delete_title'),
        content: h('div', {}, [h('p', this.$t('user_confirm_content', { name: record.name }))]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.UserDelete({ userId: record.userId })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getList(this.pagination.current);
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // 密码修改
    showChangePassword(record) {
      this.$refs.changePassword.show(record);
    },
  },
};
</script>

<style lang="less" scoped>
.logs-nav {
  a {
    margin-right: 15px;
    color: #666;
    font-size: 12px;

    &.router-link-active {
      color: #1838d9;
      font-weight: bold;
    }
  }
}
</style>
